import { loadRemoteScript } from "@/utils/scriptLoader";
import FileSaver from "file-saver";
import type html2Canvas from "html2canvas";

/**
 * 本地网页截图插件
 */
async function getHtml2Canvas() {
    if (import.meta.env.VITE_IS_QN) {
        await loadRemoteScript("https://g.alicdn.com/mtb/pcqn-temp-assets/html2canvas/1.0.0-rc.7/html2canvas.min.js");
    } else {
        await loadRemoteScript("https://cdn.fahuoyi.com/assets/third/html2canvas/1.4.1.js");
    }

    return window["html2canvas"] as typeof html2Canvas;
}

/**
 * 将html节点保存为图片文件
 */
export async function downloadHtmlToImageFile(el: HTMLElement, saveFileName: string) {
    const html2Canvas = await getHtml2Canvas();

    const canvas = await html2Canvas(el);

    return new Promise<void>((yes) => {
        canvas.toBlob((blob) => {
            const url = URL.createObjectURL(blob);

            FileSaver.saveAs(blob, saveFileName);

            URL.revokeObjectURL(url);

            canvas.remove();

            yes();
        });
    });
}

export default getHtml2Canvas;
